import { getCurrentUser } from '../../utils/currentUser';
import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_EDIT_SECTION } from '../../constants/analytics';
import {
  UpdateSectionBody,
  UpdateSectionContract,
} from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_SECTION } from '../../constants/endpoints';
import request, { getData } from './request';
import toSection from './toSection';

const patchSection = async (
  classRoomId: string,
  sectionId: string,
  section: UpdateSectionBody | undefined,
  restore = false,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled?: boolean
) => {
  const userId = getCurrentUser().id;
  const url = CLASSROOM_MATERIAL_SECTION(classRoomId, sectionId, educatorOnly);
  const data = await request<UpdateSectionContract>({
    method: 'patch',
    headers: {
      'x-correlation-id': correlationId,
    },
    url,
    data: { section, restore },
  }).then(getData);
  if (!restore) {
    try {
      analyticsTrackEvent(MATERIALS_EDIT_SECTION, {
        itemId: sectionId,
        itemType: 'Material',
        correlationId,
        folderId: section?.parent || '',
        scheduledFor: section?.scheduledFor || '',
        spaceId: data.space,
        userId,
        isRbacEnabled,
      });
    } catch {
      // Analytics must not turn a successful API request into a failed action.
    }
  }
  return toSection(data);
};

export default patchSection;
